import axios from "axios";
import { compress } from "../helpers/common.helper";
const apiUri = import.meta.env.GATEWAY_URI;

export default function useNotifications() {
  const queryNotification = async (filter, page, limit, project, sort) => {
    const reqBody = {};

    if (filter) reqBody.filter = filter;
    if (page) reqBody.page = page;
    if (limit) reqBody.limit = limit;
    if (project) reqBody.project = project;
    if (sort) reqBody.sort = sort;

    const _body = compress(JSON.stringify(reqBody));

    const result = await axios.post(
      `${apiUri}/api/v1/notifications/query`,
      _body,
      {
        headers: {
          "Content-Type": "text/plain",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );

    return result.data;
  };

  const readNotification = async (id) => {
    const result = await axios.post(
      `${apiUri}/api/v1/notifications/${id}/read`,
      null,
      {
        headers: {
          "Content-Type": "text/plain",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );

    return result?.data.data;
  };

  const getNotificationById = async (id) => {
    const result = await axios.get(`${apiUri}/api/v1/notifications/${id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    return result.data?.data;
  };

  return {
    getNotificationById,
    queryNotification,
    readNotification,
  };
}
